export default __webpack_public_path__ + "locales/uk-UA/Errors.json?hash=49aaf1d8e890cf3664dcbb802ef14599";